import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import { combineReducers } from "redux";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

// Reducers
import appReducer from "./slices/appReducer";
import authReducer from "./slices/authReducer";
import practiceReducer from "./slices/practiceReducer";
import appointmentReducer from "./slices/appointmentReducer";
import providerReducer from "./slices/providerReducer";
import patientReducer from "./slices/patientReducer";

// ✅ Persist Config
const persistConfig = {
  key: "hxf-practice-root",
  storage,
  whitelist: ["auth", "practice"], // Only persist specific reducers
};

// ✅ Combine Reducers
const appReducers = combineReducers({
  app: appReducer,
  auth: authReducer,
  practice: practiceReducer,
  appointment: appointmentReducer,
  provider: providerReducer,
  patient: patientReducer,
});

// ✅ Root Reducer with Reset Functionality
const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE") {
    storage.removeItem("persist:practice-root"); // Clear persisted storage
    return appReducers(undefined, action); // Reset store to initial state
  }
  return appReducers(state, action);
};

// ✅ Persisted Reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// ✅ Configure Store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// ✅ Persistor for Redux-Persist
export const persistor = persistStore(store);

// ✅ Reset Function (Call This to Reset Redux)
export const resetStore = () => {
  store.dispatch({ type: "RESET_STATE" }); // Reset Redux state
  persistor.purge(); // Clear persisted storage
};
